<div class="one" fxLayout="column" fxLayoutGap="16px" [formGroup]="MatterPropertyDetailsForm">
  <div fxLayout="row" fxLayoutGap="14px">
    <mat-form-field appearance="outline" fxFlex="24">
      <mat-label>Insurer</mat-label>
      <input matInput formControlName="INSURER" />
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="24">
      <mat-label>Policy Number</mat-label>
      <input matInput formControlName="POLICYNUMBER" />
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="24"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.INSURANCEEXPIRYDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.INSURANCEEXPIRYDATE),
      }"
    >
      <mat-label>Insurance Expiry Date</mat-label>
      <input
        (dateInput)="ResolutionDatepicker('input', $event)"
        (dateChange)="ResolutionDatepicker('change', $event)"
        name="resolutiondatepicker"
        matInput
        [matDatepicker]="resolutiondatepicker"
        formControlName="INSURANCEEXPIRYDATETEXT"
      />
      <mat-datepicker-toggle matSuffix [for]="resolutiondatepicker"></mat-datepicker-toggle>
      <mat-datepicker #resolutiondatepicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="24">
      <mat-label>Minimum Insurance</mat-label>
      <input
        matInput
        formControlName="MINIMUMINSURANCE"
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
      />
    </mat-form-field>
  </div>

  <div fxLayout="row">
    <div fxLayout="row" fxLayoutGap="24px">
      <mat-checkbox formControlName="BUSHFIREPRONE">Bushfire Prone</mat-checkbox>
      <mat-checkbox formControlName="FLOODPRONE">Flood Prone</mat-checkbox>
      <mat-checkbox formControlName="CYCLONEPRONE">Cyclone Prone</mat-checkbox>
    </div>
  </div>
</div>
